import { makeLoadHook } from '../../common';
import { loadUserCourse } from '../network';

export const useLoadUserCourse = makeLoadHook(loadUserCourse);
